export function Plans() {
  const plans = ['Basic', 'Advanced', 'Professional', 'Enterprise']

  // Each feature lists whether it's included per plan, in column order
  // [Basic, Advanced, Professional, Enterprise]. The tiers are cumulative:
  // higher plans include everything the lower ones do, plus more.
  const features = [
    { name: 'Secure Cloud',              tiers: [true,  true,  true,  true] },
    { name: 'Interactive Map',           tiers: [true,  true,  true,  true] },
    { name: 'Multi-level Users',         tiers: [true,  true,  true,  true] },
    { name: 'Remote Configuration',      tiers: [true,  true,  true,  true] },
    { name: 'Dashboards',                tiers: [true,  true,  true,  true] },
    { name: 'Graph, Statistics, Tables', tiers: [true,  true,  true,  true] },
    { name: 'Reports',                   tiers: [true,  true,  true,  true] },
    { name: 'Quick Alerts',              tiers: [true,  true,  true,  true] },
    { name: 'API',                       tiers: [false, true,  true,  true] },
    { name: 'Data Export Tool',          tiers: [false, true,  true,  true] },
    { name: 'Alarms',                    tiers: [false, true,  true,  true] },
    { name: 'Webcam Support',            tiers: [false, false, true,  true] },
    { name: 'Calculated Parameters',     tiers: [false, false, true,  true] },
    { name: 'Public Portal',             tiers: [false, false, true,  true] },
  ]

  // Storage rows aren't yes/no features — each shows a per-plan allowance.
  const allowances = [
    { name: 'Photo and Video Storage', values: ['',       '1GB',       '10GB',      '50GB'] },
    { name: 'Data Storage',            values: ['1-Year',  'Unlimited', 'Unlimited', 'Unlimited'] },
  ]

  return (
    <section id="plans" className="py-8 md:py-24 bg-white">
      <div className="max-w-[1920px] mx-auto px-8 sm:px-6 lg:px-[140px]">
        <h2 className="common-head28 text-3xl font-bold text-[#4D4D4D] mb-8 pb-4 border-b border-gray-200">Plans</h2>

        <div className="overflow-x-auto">
          <table className="w-full table-fixed">
            <colgroup>
              <col className="w-[34%]" />
              <col className="w-[16.5%]" />
              <col className="w-[16.5%]" />
              <col className="w-[16.5%]" />
              <col className="w-[16.5%]" />
            </colgroup>
            <thead>
              <tr className="border-b border-gray-200">
                <th className="p-4" />
                {plans.map((plan) => (
                  <th key={plan} className="common-size21 p-4 text-center text-base font-bold text-[#4D4D4D]">
                    {plan}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {features.map((feature) => (
                <tr key={feature.name} className="border-b border-gray-100">
                  <td className="common-size16 py-3 pr-4 text-sm text-[#4D4D4D]">{feature.name}</td>
                  {feature.tiers.map((included, pidx) => (
                    <td key={pidx} className="py-3 text-center">
                      {included && (
                        <img src="/images/check-right-img.png" alt="Included" className="w-5 h-5 mx-auto" />
                      )}
                    </td>
                  ))}
                </tr>
              ))}
              {allowances.map((row) => (
                <tr key={row.name} className="border-b border-gray-100">
                  <td className="py-3 pr-4 common-size16 text-[#4D4D4D]">{row.name}</td>
                  {row.values.map((value, pidx) => (
                    <td key={pidx} className="py-3 text-center common-size16 text-[#4D4D4D]">{value}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="mt-4 text-sm text-gray-500">*Unlimited Professional projects available with Enterprise</p>
      </div>
    </section>
  )
}
